import { AppState } from '../../types/types';
import React, { useContext } from 'react';
import { CustomerDataContext } from "../../components/context/CustomerDataProvider";
import { Button, Container, Grid } from "@mui/material";
import ContactChangeMobilCard from './contactChange/ContactChangeMobilCard';
import ContactChangeEmailCard from './contactChange/ContactChangeEmailCard';
import LinkedappBackend from "../../services/LinkedappBackend";
import { useEffect, useState } from "react";
import { loadSessionData, KEY_AUTH_CONTEXT } from '../../util/store';
import { AuthContext, CustomerContactStatusResponse } from "./../../types/apimodel";
import { log } from '../../util/util';


interface Props {
    appState: AppState;
}




const ContactChange: React.FC<Props> = ({ appState }) => {

    const [customerContactStatusResponse, setCustomerContactStatusResponse] = useState<CustomerContactStatusResponse | null>(null);

    const pullCustomerContactStatusResponse = () => {
        let linkid = loadSessionData('linkid');
        let authContext: AuthContext = loadSessionData(KEY_AUTH_CONTEXT);
        LinkedappBackend.getCustomerContactStatus(linkid, authContext).then((data) => {
            log("Retrieved data: ", data);
            setCustomerContactStatusResponse(data);
        }).catch(error => {
            console.log('error in getCustomerContactStatus: ' + JSON.stringify(error));
            //TODO unauthenticate if 401
        });
    }

    const zurueckZumPostfach = () => {
        log("Zurück zum Postfach");
        if (loadSessionData("kundenakteShortUrl")){
            window.location.replace(loadSessionData("kundenakteShortUrl"));
        }
    }

    useEffect(() => {
        pullCustomerContactStatusResponse();
        // Interval setzen, um die Methode alle 10 Sekunden aufzurufen
        const intervalId = setInterval(pullCustomerContactStatusResponse, 10000);
        // Cleanup-Funktion für das Aufräumen bei Komponenten-Unmount
        return () => {
            clearInterval(intervalId);
        };
    }, []);


    const { customer } = useContext(CustomerDataContext);
    console.log("Customer", customer)
    return <Container maxWidth="lg" sx={{marginTop:"40px"}}>
        <Grid container spacing={3} sx={{ overflowX: 'auto'}}>
            <ContactChangeEmailCard appState={appState} customerContactStatusResponse={customerContactStatusResponse} />
            <ContactChangeMobilCard appState={appState} customerContactStatusResponse={customerContactStatusResponse} />
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'flex-end' }} >

                <Button sx={{ fontSize: "75%", maxWidth: "140px", minWidth: "140px" }} onClick={zurueckZumPostfach} >ZURÜCK</Button>

            </Grid>
        </Grid>

    </Container>
}

export default ContactChange;